// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__A2jv3","tag--white":"Tag_tag--white__sBve0"};